// The four enums re-exported from index.ts are deliberately NOT `const enum`.
// A const enum compiles to `export declare const enum` in dist/types, and any
// consumer building with `isolatedModules` (e.g. AdoraPOS's ts-jest project)
// then fails with TS2748 "Cannot access ambient const enums" the moment it
// writes AppType.POS — the member can't be inlined one file at a time. Plain
// enums emit a real runtime object, so every consumer can use the members
// directly instead of hand-writing the string literals.
// The enums below that are NOT exported from index.ts stay `const` — they are
// library-internal and get inlined at their use sites.
export var AppType;
(function (AppType) {
    AppType["OLO"] = "OLO";
    AppType["POS"] = "POS";
    AppType["ORDERHUB"] = "ORDERHUB";
})(AppType || (AppType = {}));
export var CouponEventTypes;
(function (CouponEventTypes) {
    CouponEventTypes["ORDER_TYPE_CHANGED"] = "ORDER_TYPE_CHANGED";
    CouponEventTypes["CART_CHANGED"] = "CART_CHANGED";
    CouponEventTypes["COUPON_APPLIED"] = "COUPON_APPLIED";
    CouponEventTypes["COUPON_NOT_APPLIED"] = "COUPON_NOT_APPLIED";
    CouponEventTypes["COUPON_REMOVED"] = "COUPON_REMOVED";
})(CouponEventTypes || (CouponEventTypes = {}));
export var CouponApplyErrorCode;
(function (CouponApplyErrorCode) {
    CouponApplyErrorCode["CART_TOTAL_IS_ZERO"] = "CART_TOTAL_IS_ZERO";
    CouponApplyErrorCode["INVALID_ORDER_TYPE"] = "COUPON_INVALID_ORDER_TYPE";
    CouponApplyErrorCode["NOT_VALID_TODAY"] = "NOT_VALID_TODAY";
    CouponApplyErrorCode["MINIMUM_ORDER_AMOUNT_NOT_MET"] = "MINIMUM_NOT_MET";
    CouponApplyErrorCode["MINIMUM_QUANTITY_NOT_MET"] = "MINIMUM_QUANTITY_NOT_MET";
    CouponApplyErrorCode["COUPON_LIMIT_MET"] = "COUPON_LIMIT_MET";
    CouponApplyErrorCode["NO_QUALIFYING_ITEMS"] = "NO_QUALIFYING_ITEMS";
    CouponApplyErrorCode["UNKNOWN"] = "COUPON_UNKNOWN_ERROR";
    CouponApplyErrorCode["COUPON_TYPE_NOT_SUPPORTED"] = "COUPON_TYPE_NOT_SUPPORTED";
    CouponApplyErrorCode["COUPON_LIMIT_ONE"] = "COUPON_LIMIT_ONE";
    CouponApplyErrorCode["PROFILE_REQUIRED"] = "PROFILE_REQUIRED";
    CouponApplyErrorCode["FUNDRAISER_DOES_NOT_ALLOW_COUPON"] = "FUNDRAISER_DOES_NOT_ALLOW_COUPON";
})(CouponApplyErrorCode || (CouponApplyErrorCode = {}));
export var CouponRemoveErrorCode;
(function (CouponRemoveErrorCode) {
    CouponRemoveErrorCode["COUPON_NOT_FOUND"] = "COUPON_NOT_FOUND";
    CouponRemoveErrorCode["UNKNOWN"] = "COUPON_REMOVE_UNKNOWN_ERROR";
})(CouponRemoveErrorCode || (CouponRemoveErrorCode = {}));
//# sourceMappingURL=enums.js.map